import { LocationDescriptor } from 'history'
import * as React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router'
import { getCountryByIP } from '../../data/api/ip'
import { SiteCountry } from '../../data/models/locale'
import { AppState } from '../../data/state'
import Loader from '../../elements/Loader'

interface IpRedirectorProps {
  path: string
  userChangedCountry: boolean
  country: SiteCountry
}

interface IpRedirectorState {
  to: string
}

class IpRedirector extends React.Component<
  IpRedirectorProps,
  IpRedirectorState
> {
  public state: IpRedirectorState = {
    to: '',
  }

  public componentDidMount() {
    const { userChangedCountry, country } = this.props

    if (userChangedCountry) {
      this.setState({
        to: `/${country}${this.props.path}`,
      })
    } else {
      getCountryByIP().then(sc => {
        this.setState({
          to: `/${sc}${this.props.path}`,
        })
      })
    }
  }

  public render() {
    if (this.state.to) {
      return <Redirect to={this.state.to} />
    }
    return <Loader />
  }
}

export default connect((state: AppState) => ({
  userChangedCountry: state.locale.userChangedCountry,
  country: state.locale.country,
}))(IpRedirector)
